import React from 'react';

const sizeClasses = {
  'x-large': 'w-16 h-16 p-4',
  large: 'w-12 h-12 p-3',
  medium: 'w-10 h-10 p-2.5',
  small: 'w-8 h-8 p-2',
  'x-small': 'w-6 h-6 p-1.5',
};

export const IconWithBackground = ({ 
  icon, 
  size = 'medium', 
  square = false,
  className = ''
}) => {
  const baseClasses = 'flex items-center justify-center bg-primary-50 text-primary-600';
  const shapeClasses = square ? 'rounded-lg' : 'rounded-full';
  const sizeClass = sizeClasses[size] || sizeClasses.medium;

  return (
    <div className={`${baseClasses} ${shapeClasses} ${sizeClass} ${className}`}>
      {icon}
    </div>
  );
}; 